import { render, staticRenderFns } from "./RequestIndividualContactForDataAdministrator.vue?vue&type=template&id=31571eee&scoped=true"
import script from "./RequestIndividualContactForDataAdministrator.vue?vue&type=script&lang=js"
export * from "./RequestIndividualContactForDataAdministrator.vue?vue&type=script&lang=js"
import style0 from "./RequestIndividualContactForDataAdministrator.vue?vue&type=style&index=0&id=31571eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31571eee",
  null
  
)

export default component.exports